import { createApp } from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
import "./assets/style.scss";
import { createPinia } from "pinia";
import { createHead } from "@vueuse/head";

const appVue = createApp(App);
appVue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

appVue.config.globalProperties.$t = function (key, params) {
  return this.$vuetify.locale.t(key, params);
};

const head = createHead();
appVue.use(router).use(createPinia()).use(vuetify).use(head).mount("#app");
